module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image31.9bc50d25.webp";